var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 36,
    viewBox: "0 0 29 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.01758,
    width: 22.0504,
    height: 31.9351,
    rx: 2,
    transform: "rotate(12.694 7.01758 0)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.48996,
    y: 0.747063,
    width: 20.8004,
    height: 30.6851,
    rx: 1.375,
    transform: "rotate(12.694 7.48996 0.747063)",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.23932,
    y: 2.03241,
    width: 22.0504,
    height: 31.9351,
    rx: 2,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.86432,
    y: 2.65741,
    width: 20.8004,
    height: 30.6851,
    rx: 1.375,
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8228 21.0414H8.27294C7.99008 21.0414 7.80151 21.23 7.80151 21.5129C7.80151 21.7957 7.99008 21.9843 8.27294 21.9843H19.7757C20.0585 21.9843 20.2471 21.7957 20.2471 21.5129C20.2471 21.23 20.0585 21.0414 19.8228 21.0414Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8228 23.6343H8.27294C7.99008 23.6343 7.80151 23.8228 7.80151 24.1057C7.80151 24.3886 7.99008 24.5771 8.27294 24.5771H19.7757C20.0585 24.5771 20.2471 24.3886 20.2471 24.1057C20.2471 23.8228 20.0585 23.6343 19.8228 23.6343Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8228 26.2271H8.27294C7.99008 26.2271 7.80151 26.4157 7.80151 26.6985C7.80151 26.9814 7.99008 27.1699 8.27294 27.1699H19.7757C20.0585 27.1699 20.2471 26.9814 20.2471 26.6985C20.2471 26.4157 20.0585 26.2271 19.8228 26.2271Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.677 28.645H8.03193C7.89368 28.645 7.80151 28.7971 7.80151 29.0252C7.80151 29.2533 7.89368 29.4054 8.03193 29.4054H13.654C13.7922 29.4054 13.8844 29.2533 13.8844 29.0252C13.8844 28.7971 13.7922 28.645 13.677 28.645Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4476 9.78889H17.0965V7.43777C17.0965 7.11348 16.8263 6.84323 16.502 6.84323H12.6645C12.3402 6.84323 12.07 7.11348 12.07 7.43777V9.78889H9.71887C9.39457 9.78889 9.12433 10.0591 9.12433 10.3834V14.2209C9.12433 14.5452 9.39457 14.8154 9.71887 14.8154H12.07V17.1665C12.07 17.4908 12.3402 17.7611 12.6645 17.7611H16.502C16.8263 17.7611 17.0965 17.4908 17.0965 17.1665V14.8154H19.4476C19.7719 14.8154 20.0421 14.5452 20.0421 14.2209V10.3834C20.0421 10.0321 19.7719 9.78889 19.4476 9.78889ZM18.8801 13.6263H16.529C16.2047 13.6263 15.9345 13.8966 15.9345 14.2209V16.572H13.259V14.2209C13.259 13.8966 12.9888 13.6263 12.6645 13.6263H10.3134V10.9509H12.6645C12.9888 10.9509 13.259 10.6807 13.259 10.3564V8.00527H15.9345V10.3564C15.9345 10.6807 16.2047 10.9509 16.529 10.9509H18.8801V13.6263Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/documents_icon.e542cb4ca66d600f3b582e5e48beedc1.svg";
export { ForwardRef as ReactComponent };